/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import { translate } from 'react-i18next';

import { Row, Col } from 'react-flexbox-grid';

import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';

import teoLogo from '../assets/images/teoLogo2BlancV2.png';
import teoScreenshot1 from '../assets/images/landing/desktop-smartphone-screenshot.png';
import headerBg from '../assets/images/landing/header-background.png';

import {
  usernameChanged,
  passwordChanged,
  loginStart,
  logoutStart,
  getCurrentUser,
  passwordVisibilityToggle,
  auth0Login,
  handleAuthenticationAuth0,
  setSessionAuth0,
  logoutAuth0,
  isAuthenticatedAuth0,
  unauthorizedError,
} from '../actions';

const styles = theme => ({
  myHeaderTextContainer: {
    lineHeight: '54px',
    float: 'right',
  },
  myHeaderText: {
    color: '#FFFFFF',
    fontFamily: 'Inter-Regular',
    fontSize: 12,
    lineHeight: '54px',
  },
  contactLink: {
    color: '#FFFFFF',
    fontFamily: 'Inter-Regular',
    fontSize: 12,
    fontWeight: 'bold',
    textTransform: 'none',
    textDecoration: 'underline',
    marginLeft: 10,
    lineHeight: '54px',
    cursor: 'pointer',
  },
  myHeroTitle: {
    color: '#ffffff',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 28,
  },
  myBaseline: {
    color: '#ffffff',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 14,
  },
  mySubtitle: {
    color: '#34b2ff',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 12,
    textTransform: 'none',
  },
  myTitle: {
    color: '#1E2B38',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 20,
    textTransform: 'none',
  },
  myCard: {},
  myCardImage: {},
  myCardTitle: {
    color: '#1E2B38',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 18,
  },
  myCardDetails: {
    color: '#9CB1BB',
    fontFamily: 'Inter-Regular',
    fontSize: 12,
  },
  myCardDetailsBold: {
    color: '#1E2B38',
    fontWeight: 'bold',
    fontFamily: 'Inter-Regular',
    fontSize: 12,
  },
  myFooterText: {
    color: '#FFFFFF',
    fontFamily: 'Inter-Regular',
    fontSize: 12,
  },
  button: {
    margin: theme.spacing.unit,
    borderRadius: 24,
    backgroundColor: '#ffffff',
    color: 'rgba(52,178,255,1)',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 12,
    textTransform: 'none',
  },
  button2: {
    margin: theme.spacing.unit,
    borderRadius: 24,
    backgroundColor: 'rgba(52,178,255,0.4)',
    color: 'rgba(52,178,255,1)',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 12,
    textTransform: 'none',
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  myNumberList: {
    '&::before': {
      counterIncrement: 'li',
      content: 'counter(li)',
      position: 'absolute',
      top: '50%',
      left: -35,
      boxSizing: 'border-box',
      width: 35,
      height: 35,
      marginRight: 8,
      padding: 6,
      border: '1px solid',
      borderRadius: '50%',
      textAlign: 'center',
      transform: 'translateY(-50%)',
    },
  },
});

class Unauthorized extends Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { t, history } = this.props;
    this.props.unauthorizedError(t('unauthorized'), history);
  };

  render() {
    const { classes, loadingCheck } = this.props;
    const headerBackgroundImageValue =
      'linear-gradient(to bottom, rgba(103,60,143,1), rgba(103,60,143,0.9), rgba(103,60,143,0.8), rgba(103,60,143,0.7), rgba(78,119,199,0.6), rgba(52,178,255,0.5), rgba(255,255,255,0))';
    const footerBackgroundImageValue =
      'linear-gradient(to right, rgba(103,60,143,1), rgba(103,60,143,1), rgba(103,60,143,1), rgba(103,60,143,1), rgba(78,119,199,1), rgba(52,178,255,1))';

    if (loadingCheck) {
      return (
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <CircularProgress size={32} />
        </div>
      );
    }

    return (
      <div>
        <div
          style={{
            backgroundImage: 'url(' + headerBg + ')',
            backgroundSize: 'contain',
            backgroundRepeat: 'repeat-y',
            backgroundPosition: 'center',
          }}
        >
          <div
            style={{ backgroundImage: headerBackgroundImageValue, padding: 30 }}
          >
            <Row>
              <Col around="xs" xs={12}>
                <Row around="xs">
                  <Col xs={12} sm={12} md={10} lg={10}>
                    <Row around="xs">
                      <Col xs={6} sm={6} md={3} lg={3}>
                        <img src={teoLogo} style={{ height: 54 }} />
                      </Col>
                      <Col xs={6} sm={6} md={3} lg={3}>
                        <div className={classes.myHeaderTextContainer}>
                          <span className={classes.myHeaderText}>
                            Already register ?
                          </span>
                          <a
                            className={
                              classes.myHeaderText + ' ' + classes.contactLink
                            }
                            onClick={() => {
                              this.props.auth0Login();
                            }}
                          >
                            Log In
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row style={{ marginBottom: 30, marginTop: 20 }}>
              <Col xs={12}>
                <Row center="xs">
                  <Col xs={8} sm={6} md={6} lg={6}>
                    <span className={classes.myHeroTitle}>
                      Attributes is currently in private beta.
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ marginBottom: 30 }}>
              <Col xs={12}>
                <Row center="xs">
                  <Col xs={8} sm={6} md={6} lg={6}>
                    <span className={classes.myBaseline}>
                      If you want to have access to Attributes, you can chat
                      with us and request a demo !
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row style={{ marginBottom: 30 }}>
              <Col xs={12}>
                <Row center="xs">
                  <Col xs={8} sm={6} md={4} lg={4}>
                    <Button
                      variant="flat"
                      aria-label="Delete"
                      className={'drift-open-chat ' + classes.button}
                    >
                      Schedule a demo
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Row center="xs">
                  <Col xs={9}>
                    <img
                      src={teoScreenshot1}
                      style={{ width: '100%', maxWidth: 700 }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>

        <div
          style={{
            backgroundImage: footerBackgroundImageValue,
            padding: 30,
            color: '#ffffff',
          }}
        >
          <Row>
            <Col xs={12}>
              <p>
                <span className={classes.myFooterText}>
                  &copy; 2024 Attributes SAS
                </span>
              </p>
              <p>
                <a
                  href="mailto:contact@attributes.digital"
                  className={classes.myFooterText}
                >
                  contact@attributes.digital
                </a>
              </p>
              <p>
                <span className={classes.myFooterText}>
                  1 Place Samuel-Champlain 92400 Courbevoie France
                </span>
              </p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

Unauthorized.contextTypes = {
  router: PropTypes.object,
};
Unauthorized.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ loginReducer, router }) => {
  const {
    username,
    password,
    loading,
    user,
    passwordVisibility,
    isAuthenticated,
    loadingCheck,
  } = loginReducer;
  const { location } = router;
  return {
    username,
    password,
    loading,
    user,
    passwordVisibility,
    isAuthenticated,
    location,
    loadingCheck,
  };
};

const mapDispatchToProps = {
  usernameChanged,
  passwordChanged,
  loginStart,
  logoutStart,
  getCurrentUser,
  passwordVisibilityToggle,
  auth0Login,
  handleAuthenticationAuth0,
  setSessionAuth0,
  logoutAuth0,
  isAuthenticatedAuth0,
  unauthorizedError,
};

Unauthorized = withStyles(styles, { name: 'Unauthorized' })(Unauthorized);
Unauthorized = translate('translations')(Unauthorized);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Unauthorized)
);



// WEBPACK FOOTER //
// ./src/components/Unauthorized.js